import { Middleware } from 'redux'
import { isActionOf } from 'typesafe-actions'
import i18n from '../../../i18n/i18n'
import { storeUserGarageVehicleAsync } from '../../actions/app/userGarage.actions'
import { pushTrackingEvent } from '../../actions/tracking/tracking.actions'

const trackUserGarageButtonMiddleware: Middleware = (store) => (next) => (action) => {
    next(action)

    if (isActionOf(storeUserGarageVehicleAsync.success, action)) {
        const dataLayerEvent = {
            eventInfo: {
                eventAction: 'content',
                eventName: 'dcc save to garage',
            },
            attributes: {
                componentName: 'cartbox',
                label: i18n.t('garage.userGarage.cartboxButtonLabel'),
                currentURL: window.location.href,
                targetURL: '',
                clickID: '',
                elementName: 'button',
                value: 'vehicle-saved',
                pos: '',
            },
        }

        store.dispatch(pushTrackingEvent(dataLayerEvent))
    }
}

export default trackUserGarageButtonMiddleware
